import { ViewModel, View, ObservableArray } from "binder"
import { WindowViewModel } from "src/common/userMainWindow/windowContainer/windowContainer-viewModel";
import { ServerConnection } from "src/server/serverConnection";
import { PaginationInfo, ServerSideDataLoader } from "uicomponents";
import { IStopGroup } from "./IStopGroup";
import { StopGroupEditorViewModel, StopGroupInserter, StopGroupUpdater } from "./stopGroupEditor/stopGroupEditor-viewModel";
import { StopGroupManipulationView } from "./stopGroupManipulation-view";

export class StopGroupManipulationViewModel extends WindowViewModel {
    public getTitle(): string {
        return 'تعریف گروه توقف';
    }
    constructor(parentViewModel: ViewModel) {
        super(parentViewModel);

        this.isLoading = false;
        this.stopGroups = ObservableArray.create<StopGroup>();
        this.dataLoader = new ServerSideDataLoader(filteringInformation => this.refreshPaged(filteringInformation), 30);

        this.refresh()
    }
    GetDefaultView(): View<ViewModel> {
        return new StopGroupManipulationView();
    }
    public getTypeId(): string {
        return "VM-18FC4BF6-0BBC-444E-943A-31D09B34BB41"
    }
    public set isLoading(v: boolean) { this._isLoading = v; } public get isLoading(): boolean { return this._isLoading; } private _isLoading: boolean;
    public set stopGroups(v: ObservableArray<StopGroup>) { this._stopGroups = v; } public get stopGroups(): ObservableArray<StopGroup> { return this._stopGroups; } private _stopGroups: ObservableArray<StopGroup>;
    public set dataLoader(v: ServerSideDataLoader) { this._dataLoader = v; } public get dataLoader(): ServerSideDataLoader { return this._dataLoader; } private _dataLoader: ServerSideDataLoader;

    async refresh() {
        await this.dataLoader.refresh();
    }

    async refreshPaged(filteringInformation: any): Promise<PaginationInfo> {
        try {
            this.isLoading = true;
            let result = await ServerConnection.callServer('/Complex/StopGroupServices/ListAllStopGroups', {
                FilteringInformation: filteringInformation
            });
            this.stopGroups.update(...result.StopGroups.map((x, i) => {
                let s = new StopGroup(this);
                s.index = ((result.PaginationInfo.CurrentPage - 1) * result.PaginationInfo.PageSize) + i + 1;
                s.id = x.Id;
                s.name = x.Name;
                s.code = x.Code;
                s.isDisable = x.IsDisabled;
                return s;
            }));
            return new PaginationInfo(result.PaginationInfo.CurrentPage, result.PaginationInfo.PageCount);
        } catch (ex) {
            console.log(ex);
            return new PaginationInfo(0, 0);
        } finally {
            this.isLoading = false;
        }
    }

    async addNew() {
        let popup = new StopGroupEditorViewModel(this, new StopGroupInserter());
        let result = await this.showPopup(popup);
        if (result == 'done') {
            this.dataLoader.refresh();
        }
    }

    async edit(stopGroup: IStopGroup) {
        let popup = new StopGroupEditorViewModel(this, new StopGroupUpdater());
        await stopGroup.cloneTo(popup);
        let result = await this.requestShowingPopup(popup);
        if (result == 'done') {
            this.dataLoader.refresh();
        }
    }

    async enable(stopGroup: IStopGroup) {
        let result = await ServerConnection.callServer("/Complex/StopGroupServices/EnableStopGroup", {
            StopGroupId: stopGroup.id
        });
        if (result.IsSuccessful == true) {
            this.dataLoader.refresh();
        }
    }

    async disable(stopGroup: IStopGroup) {
        let result = await ServerConnection.callServer("/Complex/StopGroupServices/DisableStopGroup", {
            StopGroupId: stopGroup.id
        });
        if (result.IsSuccessful == true) {
            this.dataLoader.refresh();
        }
    }
}

export class StopGroup extends ViewModel implements IStopGroup {
    public getTypeId(): string { return ''; }
    public GetDefaultView(): View<ViewModel> { return null; }
    constructor(parent: StopGroupManipulationViewModel) {
        super(parent);
        this._typedParent = parent;
    }

    private _typedParent: StopGroupManipulationViewModel;
    public set index(v: number) { this._index = v; } public get index(): number { return this._index; } private _index: number;
    public set id(v: string) { this._id = v; } public get id(): string { return this._id; } private _id: string;
    public set name(v: string) { this._name = v; } public get name(): string { return this._name; } private _name: string;
    public set code(v: string) { this._code = v; } public get code(): string { return this._code; } private _code: string;
    public set isDisable(v: boolean) { this._isDisable = v; } public get isDisable(): boolean { return this._isDisable; } private _isDisable: boolean;

    async cloneTo(stopGroup: IStopGroup) {
        stopGroup.id = this.id;
        stopGroup.name = this.name;
        stopGroup.code = this.code;
        stopGroup.isDisable = this.isDisable;
    }

    async edit() {
        this._typedParent.edit(this);
    }

    async enable() {
        let isDeleted = await this.messageBoxWarningYesNo(`آیا کد گروه ${this.code} غیرفعال سازی شود؟`, `غیرفعال سازی`);
        if (isDeleted == 'yes') {
            this._typedParent.enable(this);
        }
    }

    async disable() {
        let isDeleted = await this.messageBoxWarningYesNo(`آیا کد گروه ${this.code} فعال سازی شود؟`, `فعال سازی`);
        if (isDeleted == 'yes') {
            this._typedParent.disable(this);
        }
    }
}
